import {
  DEFAULT_DESCRIPTION,
  buildPageHead,
  getSiteOrigin,
  jsonLdScript,
  organizationJsonLd,
  type HeadResult,
} from './siteMeta'

// Brand first: Google was rewriting the brand-last variant to put "Mátevolno"
// up front anyway, so we author the form we want shown.
const HOME_TITLE = 'Mátevolno – last-minute ubytování: chalupy, chaty a penziony'

/**
 * Homepage head: a keyword-rich title/description plus the site-wide
 * Organization + WebSite JSON-LD (emitted only here). Shared by the runtime
 * home route and the build-time prerender script, so crawlers without JS get
 * the same tags baked into dist/index.html.
 */
export function buildHomeHead(origin: string = getSiteOrigin()): HeadResult {
  const base = buildPageHead({
    title: HOME_TITLE,
    description: DEFAULT_DESCRIPTION,
    path: '/',
    origin,
  })

  return {
    ...base,
    scripts: [jsonLdScript(organizationJsonLd(origin))],
  }
}
